import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { getAllPrizeHistoryQuery } from "../../../redux/slices/giftsProductsSlice";
import { convertDate } from "../../../utils/utils";

const SendingGiftsTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getAllPrizeHistoryLoading = useSelector(
    (state) => state.giftsProducts.getAllPrizeHistoryLoading
  );
  const getAllPrizeHistoryError = useSelector(
    (state) => state.giftsProducts.getAllPrizeHistoryError
  );
  const allGiftsForSending = useSelector(
    (state) => state.giftsProducts.allPrizeHistory
  );
  const allPrizeCount = useSelector(
    (state) => state.giftsProducts.allPrizeCount
  );

  const columns = [
    { id: "id", label: t("adminPrizeHistory.id"), minWidth: 100 },
    { id: "username", label: t("adminPrizeHistory.username"), minWidth: 100 },
    { id: "createdAt", label: t("adminPrizeHistory.createdAt"), minWidth: 100 },
    { id: "prize", label: t("adminPrizeHistory.prize"), minWidth: 170 },
    {
      id: "shippingInfo",
      label: t("adminPrizeHistory.userInfo"),
      minWidth: 170,
    },
    // { id: "action", label: t("adminPrizeHistory.action"), minWidth: 100 },
  ];
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(+event.target.value);
   
  };

  useEffect(() => {
    dispatch(getAllPrizeHistoryQuery({ page, pageSize: rowsPerPage }));
  }, [dispatch]);
  useEffect(()=>{
    dispatch(getAllPrizeHistoryQuery({ page, pageSize: rowsPerPage }));
  },[page, rowsPerPage])

  const getPrizeColumn = (value) => {
    return <Typography variant="body">{value.name}</Typography>;
  };
  const getUserInfo = (value) => {
    return (
      <Stack display="flex" direction="column">
        <Stack display="flex" direction="row">
          <Typography variant="caption">
            <b>{t("adminPrizeHistory.name")}: </b>
          </Typography>
          <Typography component="div" marginLeft="4px" variant="caption">
            {value?.[0].name}
          </Typography>
        </Stack>
        <Stack display="flex" direction="row">
          <Typography variant="caption">
            <b>{t("adminPrizeHistory.surname")}: </b>
          </Typography>
          <Typography component="div" marginLeft="4px" variant="caption">
            {value?.[0].surname}
          </Typography>
        </Stack>
        <Stack display="flex" direction="row">
          <Typography variant="caption">
            <b>{t("adminPrizeHistory.idNum")}: </b>
          </Typography>
          <Typography component="div" marginLeft="4px" variant="caption">
            {value?.[0].idNum}
          </Typography>
        </Stack>
        <Stack display="flex" direction="row">
          <Typography variant="caption">
            <b>{t("adminPrizeHistory.email")}: </b>
          </Typography>
          <Typography component="div" marginLeft="4px" variant="caption">
            {value?.[0].email}
          </Typography>
        </Stack>
        <Stack display="flex" direction="row">
          <Typography variant="caption">
            <b>{t("adminPrizeHistory.phoneNumber")}: </b>
          </Typography>
          <Typography component="div" marginLeft="4px" variant="caption">
            {value?.[0].phoneNumber}
          </Typography>
        </Stack>
        <Stack display="flex" direction="row">
          <Typography variant="caption">
            <b>{t("adminPrizeHistory.address")}: </b>
          </Typography>
          <Typography component="div" marginLeft="4px" variant="caption">
            {value?.[0].address}
          </Typography>
        </Stack>
        <Stack display="flex" direction="row">
          <Typography variant="caption">
            <b>{t("adminPrizeHistory.city")}: </b>
          </Typography>
          <Typography component="div" marginLeft="4px" variant="caption">
            {value?.[0].city}
          </Typography>
        </Stack>
      </Stack>
    );
  };

  const getDateColumn = (value) => {
    return convertDate(value);
  };
  const getColumnUsername = (value) => {
    return value.attributes.shippingInfo[0].username || "n/a";
  };
  return (
    <>
      {getAllPrizeHistoryLoading === "PENDING" ? (
        <Stack
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Stack>
      ) : getAllPrizeHistoryError ? (
        <Alert variant="error">{getAllPrizeHistoryError.message}</Alert>
      ) : (
        <Paper sx={{ width: "100%", overflow: "auto" }}>
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allGiftsForSending?.map((row) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.id}
                    >
                      {columns.map((column) => {
                        const value = row.attributes[column.id];
                        const rowId = row.id;
                        return (
                          <TableCell key={column.id}>
                            {column.id === "prize"
                              ? getPrizeColumn(value)
                              : column.id === "shippingInfo"
                              ? getUserInfo(value)
                              : column.id === "createdAt"
                              ? getDateColumn(value)
                              : column.id === "username"
                              ? getColumnUsername(row)
                              : rowId}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={allPrizeCount || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </>
  );
};

export default SendingGiftsTable;
